import { prop } from "../../decorators/property";

export class StatuteOutlineModel extends Backbone.AssociatedModel {
    @prop() public Id: any;
    @prop() public WholeActUrl: string;
    @prop() public WholeActDocKey: string;
    @prop() public Preamble: any; // object
    @prop() public Parts: any;  // array
    @prop() public Schedules: any;
    @prop() public HasCommencements: boolean;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/statute-outline.ts